import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RecordRoutingModule } from './record-routing.module';
import { DailyRecordComponent } from './components/daily-record/daily-record.component';
import { RecordItemComponent } from './components/record-item/record-item.component';
import { RecordDisplaySettingComponent } from './record-display-setting/record-display-setting.component';
import { SharedModule } from '@app/shared/shared.module';
import { RecordDetailComponent } from './record-detail/record-detail.component';
import { ComponentsSharedModule } from '@app/components/components-shared.module';
import { UserRecordSelectComponent } from './user-record-select/user-record-select.component';
import { RecordAddComponent } from './record-add/record-add.component';
import { RecordEditComponent } from './record-edit/record-edit.component';
import { ScheduleNoteEditComponent } from './schedule-note-edit/schedule-note-edit.component';
import { RecordKidsComponent } from './record-kids/record-kids.component';
import { UserSelectModule } from '@app/basic/components/user-select/user-select.component';
import { RecordListNavigateComponent } from './record-based/record-list-based.component';

@NgModule({
  declarations: [
    RecordItemComponent,
    DailyRecordComponent,
    RecordDisplaySettingComponent,
    RecordDetailComponent,
    UserRecordSelectComponent,
    RecordAddComponent,
    RecordEditComponent,
    ScheduleNoteEditComponent,
    RecordKidsComponent,
    RecordListNavigateComponent
  ],
  imports: [
    CommonModule,
    RecordRoutingModule,
    SharedModule,
    ComponentsSharedModule,
    UserSelectModule,
  ],
  exports: [
    DailyRecordComponent,
  ]
})
export class RecordModule {}
